import React from 'react'

const Feedback = () => {
  return (
 <>

<div class="mt-12 px-64 sm:px-4 py-16 products bg-gray-200" id="contact">
  <div class="py-2 flex flex-col justify-between align-text-bottom gap-0" >

    <span class=" WebsiteName text-sky-600 animate-flip-up animate-delay-0 text-5xl sm:text-4xl"
      >
      contact._</span>
      <span class="flex flex-col">
      <span class="  font-bold text-gray-900 animate-flip-up animate-delay-0 text-3xl sm:text-4xl">
      Interested ?</span>
      <span class="  font-bold text-gray-900 animate-flip-up animate-delay-0 text-3xl sm:text-4xl">
        Lets Get In Touch !</span></span>
  </div>
<div class="flex flex-row sm:flex-wrap-reverse gap-6 sm:gap-4 ">

  <div>
    <form action="https://getform.io/f/71066576-9c3c-4fa1-8909-a2a00b969f9a" method="POST" class='flex flex-col gap-2'>
      <div>
           {/* <!-- <label htmlFor="name">Name:</label>  --> */}
          <input type="text" id="name" name="name" placeholder="Enter your name" class="rounded shadow ps-2 py-2 border border-sky-950/50 text-sm w-80"/>
      </div>
      <div>
           {/* <!-- <label htmlFor="email">Email:</label>  --> */}
          <input type="email" id="email" name="email" placeholder="Enter your email" class="rounded shadow ps-2 py-2 border border-sky-950/50 text-sm w-80" />
      </div>
      
      <div>
          {/* <!-- <label htmlFor="message">Message:</label> --> */}
          <textarea type="text" id="message" name="message" placeholder="Enter your message" class="rounded shadow ps-2 py-2 border border-sky-950/50 text-sm w-80" ></textarea>
      </div>
      <button type="submit" class="text-white bg-black w-36 px-5 py-1 rounded-lg shadow animate-bounce">Send <i class="bi bi-send-fill text-sky-600"></i></button>
  </form>
  </div>

  <div className='products italic'>
    <span>
      <button
        class="text-sm text-sky-900 italic font-semibold rounded-full   flex flex-row align-middle gap-1 animate-fade-right">
        <i class="bi bi-phone-fill"></i>
        +91 9440267786</button>
    </span>
    <span>
      <button
        class="text-sm text-sky-900 italic font-semibold rounded-full pt-2  flex flex-row align-middle gap-1 animate-fade-right  animate-delay-500">
        <i class="bi bi-envelope-fill"></i>
        shaikshafieluru@gmail.com</button>
    </span>
    <span>
      <button
        class="text-sm text-sky-900 italic font-semibold rounded-full pt-2  flex flex-row align-middle gap-1 animate-fade-right animate-delay-1000">
        <i class="bi bi-linkedin"></i>
        linkedin.com/in/shaik-shafi-eluru/</button>
    </span>
    <span>
      <button
        class="text-sm text-sky-900 italic font-semibold rounded-full pt-2  flex flex-row align-middle gap-1 animate-fade-right animate-delay-[1500ms]">
        <i class="bi bi-github"></i>
        github.com/shafi099</button>
    </span>
  </div>

</div>

  </div>




  <div class="py-6 flex items-center justify-center products italic">
    <span>
      Developed by @Shafi Shaik 🌊
    </span>
  </div>
  </>
  )
}

export default Feedback